import React from 'react';
import { c as classnames } from '../../index-2586sEvh.js';
import '../../_commonjsHelpers-jjO7Zipk.js';

/**
 * Basic button component
 */
const ButtonGroup = ({ children, align = 'space-between', fullWidth = false, vertical = 'max-768', className = '', }) => {
    const verticalClass = vertical === 'always' ? 'vertical' : `vertical-${vertical}`;
    return (React.createElement("div", { className: classnames(`button-group align-${align} ${fullWidth ? 'full-width' : ''} ${verticalClass} ${className}`) }, children));
};

export { ButtonGroup as default };
//# sourceMappingURL=index.js.map
